import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/deleteScenario';
import { fetchRequest as refreshScenarios } from '../../actions/discovery/scenarios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId, scenarioId } = action?.payload || {};
    const response = yield call(
      axios.delete,
      `${config.API_URL}/goals/scenarios/${scenarioId}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess({ ...(response?.data?.data || {}), scenarioId }));
    // Refresh the saved list so the deleted scenario disappears immediately.
    if (goalId) yield put(refreshScenarios({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
